import {
    cartActions,
    cartSelectors,
    CartMode,
    CartItemTypes,
} from './cartSlice'
import { userSelectors } from '../../redux/userSlice'
import { fetchHelper } from '../../api/api'
import { store } from '../../redux/store'
import notification from '../../components/Notification/notification'
import { fetchPlan } from '../Plans/plansApi'
import { fetchCourseDetails, fetchClassDetails } from '../../api/apiFunctions'
import { isNetworkError } from '../../util/functions'

export const addCourseToCart = ({
    id,
    course: courseInfo,
    free = false,
}) => async (dispatch, getState) => {
    try {
        const state = getState()
        const mode = cartSelectors.mode(state)
        const items = cartSelectors.cartItems(state)
        // We already have the same exact item in the cart, ignore it
        if (
            items.some(
                cartItem =>
                    cartItem.type === CartItemTypes.Course && cartItem.id === id
            )
        )
            return true
        if (mode === CartMode.ClientSide) {
            dispatch(
                cartActions.addItem({
                    type: CartItemTypes.Course,
                    id,
                    free,
                    itemDetail: courseInfo,
                })
            )
        } else {
            const { cartItemId } = await addItemToServerCart({
                id,
                type: CartItemTypes.Course,
                free,
            })
            dispatch(
                cartActions.addItem({
                    cartItemId,
                    type: CartItemTypes.Course,
                    id,
                    free,
                    itemDetail: courseInfo,
                })
            )
        }
        return true
    } catch (error) {
        console.log('gaddo', error)
        // TODO: Error notification
        if (process.env.NODE_ENV === 'development') console.warn(error)
        throw error
    }
}

export const addClassToCart = ({
    id,
    invites,
    classInfo,
    numFree = 0,
}) => async (dispatch, getState) => {
    try {
        const state = getState()
        const mode = cartSelectors.mode(state)
        const items = cartSelectors.cartItems(state)
        if (
            items.some(
                cartItem =>
                    cartItem.type === CartItemTypes.Class && cartItem.id === id
            )
        )
            return true
        if (mode === CartMode.ClientSide) {
            dispatch(
                cartActions.addItem({
                    type: CartItemTypes.Class,
                    id,
                    itemDetail: classInfo,
                    invites,
                    numFree,
                })
            )
        } else {
            const { cartItemId } = await addItemToServerCart({
                id,
                type: CartItemTypes.Class,
                invites,
                numFree,
            })
            dispatch(
                cartActions.addItem({
                    cartItemId,
                    type: CartItemTypes.Class,
                    id,
                    invites,
                    itemDetail: classInfo,
                    numFree,
                })
            )
        }
        return true
    } catch (error) {
        // TODO: Error notification
        if (process.env.NODE_ENV === 'development') console.warn(error)
        return false
    }
}

export const selectPlan = ({ id, planInfo }) => async (dispatch, getState) => {
    try {
        const state = getState()
        const mode = cartSelectors.mode(state)
        if (mode === CartMode.ClientSide) {
            dispatch(
                cartActions.selectPlan({
                    id,
                    itemDetail: planInfo,
                })
            )
        } else {
            const { cartItemId } = await addItemToServerCart({
                id,
                type: CartItemTypes.Plan,
            })
            dispatch(
                cartActions.selectPlan({
                    cartItemId,
                    id,
                    itemDetail: planInfo,
                })
            )
        }
        return true
    } catch (error) {
        // TODO: Error notification
        if (process.env.NODE_ENV === 'development') console.warn(error)
        return false
    }
}

export const deselectPlan = () => async (dispatch, getState) => {
    try {
        const state = getState()
        const mode = cartSelectors.mode(state)
        const selectedPlan = cartSelectors.selectedPlan(state)
        if (!selectPlan) return true
        const { cartItemId } = selectedPlan
        if (mode === CartMode.ClientSide) {
            dispatch(cartActions.deselectPlan())
        } else {
            await removeItemFromServerCart({
                cartItemId,
            })
            dispatch(cartActions.deselectPlan())
        }
        return true
    } catch (error) {
        // TODO: Error notification
        if (process.env.NODE_ENV === 'development') console.warn(error)
        return false
    }
}

export const removeItem = ({ cartItemId }) => async (dispatch, getState) => {
    try {
        const state = getState()
        const mode = cartSelectors.mode(state)
        if (mode === CartMode.ClientSide) {
            dispatch(cartActions.removeItem({ cartItemId }))
        } else {
            await removeItemFromServerCart({
                cartItemId,
            })
            dispatch(cartActions.removeItem({ cartItemId }))
        }
        return true
    } catch (error) {
        // TODO: Error notification
        if (process.env.NODE_ENV === 'development') console.warn(error)
        return false
    }
}

export const removeAllItems = () => async (dispatch, getState) => {
    try {
        const state = getState()
        const mode = cartSelectors.mode(state)
        if (mode === CartMode.ClientSide) {
            dispatch(cartActions.removeAllItems())
        } else {
            await removeAllItemsFromServerCart()
            dispatch(cartActions.removeAllItems())
        }
        return true
    } catch (error) {
        // TODO: Error notification
        if (process.env.NODE_ENV === 'development') console.warn(error)
        return false
    }
}

const addItemToServerCart = async ({ id, type, invites, free, numFree }) => {
    const state = store.getState()
    const userDetails = userSelectors.userDetails(state)

    const response = await fetchHelper.post(
        `Cart/AddToCart/${userDetails.email}`,
        {
            cartItemId: id,
            cartItem: type,
            invites: JSON.stringify(invites) ?? '',
            free: free ?? false,
            numFree: numFree ?? 0,
        }
    )

    const { id: cartItemId } = response.data

    return {
        cartItemId,
    }
}

const removeItemFromServerCart = ({ cartItemId }) => {
    const state = store.getState()
    const userDetails = userSelectors.userDetails(state)

    return fetchHelper.delete(
        `Cart/RemoveCartItem/CustomerEmail?customerEmail=${userDetails.email}`,
        {
            headers: {
                'Content-Type': 'application/json',
            },
            data: `${cartItemId}`,
        }
    )
}

const removeAllItemsFromServerCart = () => {
    const state = store.getState()
    const userDetails = userSelectors.userDetails(state)

    return fetchHelper.delete(`Cart/clearCart/${userDetails.email}`)
}

export const syncCartWithBackend = () => async (dispatch, getState) => {
    try {
        const state = getState()
        const { email } = userSelectors.userDetails(state)
        const mode = cartSelectors.mode(state)
        const cartItems = cartSelectors.cartItems(state)
        const plan = cartSelectors.selectedPlan(state)
        let uploadItems = cartItems.map(
            ({ invites, type, free, numFree, id }) => ({
                cartItem: type,
                cartItemId: id,
                free,
                numFree,
                invites: JSON.stringify(invites) ?? '',
            })
        )
        if (!!plan)
            uploadItems.push({
                cartItem: plan.type,
                cartItemId: plan.id,
            })
        let downloadPromises = []
        if (mode === CartMode.ClientSide) {
            // use the bulk upload endpoint to upload offline cart items
            await fetchHelper.post(`Cart/Bulk/${email}`, uploadItems)
        }

        // Replace the cart with items from the backend with the benefit of
        // getting anything that's already in the cart
        const response = await fetchHelper.get(
            `Cart/CustomerEmail?customerEmail=${email}`
        )
        const items = response.data.map(
            ({ id, cartItem, cartItemId, invites, free, numFree }) => ({
                cartItemId: id,
                id: cartItemId,
                type: cartItem,
                invites: !!invites ? JSON.parse(invites) : [],
                free,
                numFree,
            })
        )
        // Attach each item's details to them
        downloadPromises = items.map(async item => {
            let itemDetail = null
            try {
                if (item.type === CartItemTypes.Course)
                    itemDetail = await fetchCourseDetails(item.id)
                else if (item.type === CartItemTypes.Class)
                    itemDetail = await fetchClassDetails(item.id)
                else itemDetail = await fetchPlan(item.id)
                return {
                    ...item,
                    itemDetail,
                }
            } catch (error) {
                if (error?.response.status === 404) {
                    // The item no longer exists
                    return { deleted: true, ...item }
                } else {
                    // An unknown error (perhaps network error) occured
                    // Rethrow so it can get caught later
                    throw error
                }
            }
        })

        let itemsWithDetails = await Promise.all(downloadPromises)
        const deletedItems = itemsWithDetails.filter(item => item.deleted)
        const existingItems = itemsWithDetails.filter(item => !item.deleted)

        const deletePromises = deletedItems.map(({ cartItemId }) =>
            removeItemFromServerCart({ cartItemId })
        )
        await Promise.all(deletePromises)

        dispatch(cartActions.getServerCart(existingItems))

        if (deletedItems.length > 0) {
            notification.info({
                title: 'Removed deleted cart items',
                description:
                    'Some items in your cart no longer exist and have been removed.',
            })
        }
    } catch (error) {
        if (process.env.NODE_ENV === 'development') console.warn(error)
        if (isNetworkError(error)) {
            // notification.failure({
            //     title: 'Failed to sync cart',
            //     description:
            //         'A network error occured. Kindly reload the page to retry.',
            // })
        } else {
            throw error
        }
    }
}
